export default __webpack_public_path__ + "static/side-nav-dont-9-e0e40f726a1f82f8d275d8a9a479edaee2fa57b0d6616abe0cb07fcdbf78250d.png";